import React, { useState, useEffect } from "react";
import { Search, Menu, X } from "lucide-react";
import "../styles/Header.css";
import LoginModal from "./LoginModal";
import fipiLogo from "../assets/images/fipi-logo-white.png";
import RegisterModal from "./RegisterModal";
import { useNavigate } from "react-router-dom";

const Header = ({
  onLogin,
  isLoggedIn,
  userRole,
  onLogout,
  onLoginClick,
  onRegister,
  onRegisterClick,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginType, setLoginType] = useState("");
  const [postLoginAction, setPostLoginAction] = useState(() => {});
  const [registerType, setRegisterType] = useState("");
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [postRegisterAction, setPostRegisterAction] = useState(() => {});
  const [firstName, setFirstName] = useState("");

  const navigate = useNavigate();

  // Helper: safely get first name from localStorage 'user_info'
  const getFirstNameFromStorage = () => {
    try {
      const raw = sessionStorage.getItem("user_info");
      if (!raw) return "";
      const user = JSON.parse(raw);
      // accept multiple possible key names to be robust
      return (
        user.first_name || user.firstname || user.firstName || user.name || ""
      );
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
      return "";
    }
  };

  // When component mounts or login state changes, refresh the shown first name
  useEffect(() => {
    if (isLoggedIn) {
      const name = getFirstNameFromStorage();
      setFirstName(name);
    } else {
      // clear when logged out
      setFirstName("");
    }
  }, [isLoggedIn]);

  const handleLoginClickLocal = (type, action = () => {}) => {
    setLoginType(type);
    setShowLoginModal(true);
    setPostLoginAction(() => action);
    if (typeof onLoginClick === "function") onLoginClick(type, action);
  };

  const handleRegisterClickLocal = (type, action = () => {}) => {
    setRegisterType(type);
    setShowRegisterModal(true);
    setPostRegisterAction(() => action);
    if (typeof onRegisterClick === "function") onRegisterClick(type, action);
  };

  const Logout = () => {
    sessionStorage.clear();
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="header-top">
        {/* optional left logo (if you want) */}
        {/* <div className="logo-container">
          <img src={fipiLogo} alt="logo" className="logo" />
        </div> */}

        {/* Desktop Actions (Search and Login or User Section) */}
        {!isLoggedIn ? (
          <div className="desktop-actions">
            {/* Uncomment search if you want */}
            {/* <div className="search-container">
              <Search className="search-icon" size={16} />
              <input
                type="text"
                placeholder="Search awards, applicants..."
                className="search-input"
              />
            </div> */}
            <div className="login-buttons">
              <button
                onClick={() => handleLoginClickLocal("user")}
                className="btn btn-primary"
              >
                Login
              </button>
              {/* <button
                onClick={() => handleRegisterClickLocal("user")}
                className="btn btn-primary"
              >
                Registration
              </button> */}
            </div>
          </div>
        ) : (
          <div className="user-section">
            <span className="welcome-text">
              {/* prefer firstName, fallback to role-based label */}
              {firstName
                ? `Welcome,   ${firstName}`
                : `Welcome, ${userRole === "admin" ? "Admin" : "User"}`}
            </span>
            <button onClick={Logout} className="btn btn-danger btn-sm">
              Logout
            </button>
          </div>
        )}

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {!isLoggedIn ? (
            <>
              <div className="mobile-search">
                <input
                  type="text"
                  placeholder="Search awards, applicants..."
                  className="form-input"
                />
              </div>
              <div className="mobile-login-buttons">
                <button
                  onClick={() => handleLoginClickLocal("user")}
                  className="btn btn-primary"
                >
                  Login
                </button>

                <button
                  onClick={() => handleRegisterClickLocal("user")}
                  className="btn btn-primary"
                >
                  Registration
                </button>
              </div>
            </>
          ) : (
            <div className="mobile-user-section">
              <p className="welcome-text">
                {firstName
                  ? `Welcome, ${firstName}`
                  : `Welcome, ${userRole === "admin" ? "Admin" : "User"}`}
              </p>
              <button
                onClick={() => {
                  if (typeof onLogout === "function") onLogout();
                  setFirstName("");
                }}
                className="btn btn-danger"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}

      {/* Render LoginModal conditionally */}
      {showLoginModal && (
        <LoginModal
          type={loginType}
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={(role) => {
            // Inform parent
            if (typeof onLogin === "function") onLogin(role);

            // close modal
            setShowLoginModal(false);

            // refresh first name from localStorage (LoginModal / auth should set it)
            const name = getFirstNameFromStorage();
            setFirstName(name);

            // run any stored post-login action
            try {
              postLoginAction();
            } catch (err) {
              console.warn("postLoginAction failed:", err);
            }
            // clear stored action
            setPostLoginAction(() => {});
          }}
        />
      )}

      {showRegisterModal && (
        <RegisterModal
          type={registerType}
          onClose={() => setShowRegisterModal(false)}
          onRegisterSuccess={() => {
            setShowRegisterModal(false);
            // optionally run post-register action (if provided)
            try {
              postRegisterAction();
            } catch (err) {
              console.warn("postRegisterAction failed:", err);
            }
            setPostRegisterAction(() => {});

            // Typical UX: prompt user to log in after registration
            alert("Registration successful! Please log in.");
            // if you want to navigate to a login route instead uncomment:
            // navigate('/login');
          }}
        />
      )}
    </header>
  );
};

export default Header;
